angular.module('invoice')
    .constant('KsefConst', {
        downloaded: 'ksef.downloaded'
    })
    .factory('Ksef', function ($resource) {
        return $resource('crm/api/ksef/:id', { id: '@id' }, {
            table: {method: 'GET', isArray: false, url: 'crm/api/ksef/table'},
            tableStatistics: {method: 'GET', isArray: false, url: 'crm/api/ksef/table-statistics'},
            generateDf: {method: 'POST', url: 'crm/api/ksef/:id/generate-df'},
            generateDfByRules: {method: 'POST', url: 'crm/api/ksef/:id/generate-df-by-rules'},
            removeEntry: {method: 'DELETE', url: 'crm/api/ksef/:id'},
            deleteBatch: {method: 'POST', url: 'crm/api/ksef/batch-delete'},
        });
    })
    .service('KsefService', function ($rootScope, $state, toastr, modals, Ksef, KsefConst){
        this.subjectTypes = () => ['SUBJECT1', 'SUBJECT2', 'SUBJECT3', 'SUBJECTAUTHORIZED']
        this.types = () => ['VAT', 'ZAL', 'KOR', 'ROZ', 'UPR', 'KOR_ZAL', 'KOR_ROZ', 'VAT_PEF', 'KOR_PEF', 'KOR_VAT_RR']

        this.generateDf = (id) => {
            Ksef.generateDf({id : id}).$promise.then(response => {
                toastr.success('Dodano DF')
                $state.go('invoiceRegistration', {id: response.id})
            })
        }

        this.generateDfByRules = (id) => {
            Ksef.generateDfByRules({id : id}).$promise.then(response => {
                toastr.success('Dodano DF')
                $state.reload()
            })
        }

        this.remove = (item) => {
            if (!item || !item.id) {
                return
            }
            let content = 'Czy na pewno chcesz usunąć wpis z rejestru KSeF?'
            if (item && item.invoiceNumber) {
                content += '<br><b>Numer:</b> ' + item.invoiceNumber
            }
            if (item && item.ksefNumber) {
                content += '<br><b>KSeF:</b> ' + item.ksefNumber
            }
            return modals.confirm(content, () => {
                return Ksef.removeEntry({id: item.id}).$promise.then(() => {
                    toastr.success('Usunięto wpis KSeF')
                    $state.reload()
                })
            })
        }

        this.removeMany = items => {
            const ids = (items || []).map(item => item && item.id).filter(id => id != null).filter((id, index, values) => values.indexOf(id) === index)
            if (!ids.length) {
                return
            }
            return modals.confirmDelete(`zaznaczone rekordy (${ids.length})`, () => Ksef.deleteBatch({ids: ids}).$promise.then(() => $state.reload()))
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('ksefList', {
            parent: 'app',
            url: '/ksef?{page:int}&{size:int}&sort&search&start&end&type&currency&status&subjectType&dateType&clients',
            // data: {
            //     authorities: ['ROLE_ADMIN']
            // },
            params: {
                type: {array: true, value: [], squash: false},
                status: {array: true, value: [], squash: false},
                dateType: {value: 'PermanentStorage', squash: false},
                subjectType: {value: 'SUBJECT2', squash: false}
            },
            views: {
                'content@': 'ksefList'
            },
            resolve: {
                statistics: (Ksef, $stateParams) => Ksef.tableStatistics(angular.copy($stateParams)).$promise,
                filters: $stateParams => angular.copy($stateParams),
                page: (Ksef, $stateParams) => Ksef.table(angular.copy($stateParams)).$promise
            }
        })
        $stateProvider.state('ksefConfig', {
            parent: 'app',
            url: '/ksef-config',
            views: {
                'content@': 'ksefConfig'
            }
        })
        $stateProvider.state('ksefConfigAssignment', {
            parent: 'app',
            url: '/ksef-config/:id/assignment?query&filterRuleType&filterBuyerClientId&filterUserId&sort',
            params: {
                query: {value: null, squash: true},
                filterRuleType: {value: null, squash: true},
                filterBuyerClientId: {value: null, squash: true},
                filterUserId: {value: null, squash: true},
                sort: {value: null, squash: true}
            },
            views: {
                'content@': 'ksefConfigAssignment'
            }
        })
        $stateProvider.state('ksefGlobalAssignment', {
            parent: 'app',
            url: '/ksef-assignment-global?query&filterRuleType&filterBuyerClientId&filterUserId&sort',
            params: {
                query: {value: null, squash: true},
                filterRuleType: {value: null, squash: true},
                filterBuyerClientId: {value: null, squash: true},
                filterUserId: {value: null, squash: true},
                sort: {value: null, squash: true}
            },
            views: {
                'content@': 'ksefConfigAssignment'
            }
        })
        $stateProvider.state('ksefAllAssignment', {
            parent: 'app',
            url: '/ksef-assignment-all?query&filterRuleType&filterBuyerClientId&filterUserId&sort',
            params: {
                query: {value: null, squash: true},
                filterRuleType: {value: null, squash: true},
                filterBuyerClientId: {value: null, squash: true},
                filterUserId: {value: null, squash: true},
                sort: {value: null, squash: true}
            },
            views: {
                'content@': 'ksefConfigAssignment'
            }
        })
    })
